export const navLinks = [
  { title: "Home", path: "/" },
  { title: "About Me", path: "/about" },
  { title: "Portfolio", path: "/portfolio" },
  { title: "Experience", path: "/experience" },
  { title: "Resume", path: "/resume" },
  { title: "Tools", path: "/tools" },
];

export const projects = [
  {
    title: "IST 413",
    subtitle: "CareBnB Adobe xD Prototype",
    href: "./fileFolder/CareBnB_StoryBoard_All_Streamlined_FontRoboto.xd",
  },
  {
    title: "IST 505",
    subtitle: "Project Proposal Presentation",
    href: "./fileFolder/IST505-ProposalPresentation.pptx",
  },
  // ... add the rest of your projects
];

export const socialLinks = [
  {
    name: "GitHub",
    url: "https://github.com/bxe5056",
    icon: "FaGithub",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/benjamindeppingerpsu",
    icon: "FaLinkedin",
  },
  // ... other social links
];
